const recentRequests = new Set();

/**
 * Function to avoid duplicated executions
 */
function ensureSingleExecution({ req, res }, next) {
  const { body, path = "" } = req;
  const baseId = body?.requestId;

  if (!baseId) return next();

  const id = `${path}:${baseId}`;

  if (recentRequests.has(id)) {
    console.error("Duplicate request");
    res.status = 204;
    return;
  }
  recentRequests.add(id);

  // Clean after 10 seconds
  setTimeout(() => recentRequests.delete(id), 10000);
  return next();
}

export default ensureSingleExecution;
